export enum ErrorHandlerTypes {
    NO_ACTION = 1,
    SHOW_ALERT_MESSAGE = 2,
    SHOW_DIALOG_MESSAGE = 3,
    REDIRECT_TO_NOT_FOUND_PAGE = 4,
    REDIRECT_TO_ERROR_PAGE = 5,
    REDIRECT_TO_LOGIN_PAGE = 6,
    SHOW_LOGIN_DIALOG = 7
}